module.exports = __webpack_public_path__ + "img/ttl_step_03.e100e895.svg";